<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElInput v-model="keyword" placeholder="被推送账号/计划主ID" style="width: 180px" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem label-width="38" label="状态">
          <el-select v-model="stats" :popper-append-to-body="false" clearable filterable placeholder="全部" style="width: 120px">
            <el-option v-for="item in statData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label-width="38" label="媒体">
          <el-select v-model="mediaId" :popper-append-to-body="false" clearable filterable placeholder="全部" style="width: 120px">
            <el-option v-for="item in mediaData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="推送人">
          <el-select v-model="pushOpId" :popper-append-to-body="false" clearable filterable placeholder="全部" style="width: 120px">
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { isEmpty, trim } from '@/common/js/utils'
import { initPageData, SYS_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS])
export default {
  name: 'PushFilter',
  props: {
    mediaData: {
      type: Array
    },
    statData: {
      type: Array
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  data() {
    return {
      stats: '',
      mediaId: '',
      pushOpId: '',
      keyword: ''
    }
  },
  methods: {
    sendEvent() {
      const params = {
        keyword: isEmpty(this.keyword) ? undefined : trim(this.keyword),
        status: this.stats === '' ? undefined : this.stats,
        mediaId: this.mediaId === '' ? undefined : this.mediaId,
        pushOpId: this.pushOpId === '' ? undefined : this.pushOpId
      }
      this.$emit('on-change', params)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-filter {
  width: 100%;
  padding-top: 6px;
  display: flex;
  justify-content: space-between;

  .c-form {
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
